import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloudContracts from "../../../1.resources/2.js/0.global/2.contracts/cloudContracts";
import { colors } from "../../../1.resources/1.css/colors";
import Logo from "../../../1.resources/3.files/logo/logo_color.webp";

const punycode = require('punycode/');

class HeaderSearch extends React.Component {

    componentDidMount() {
        document.getElementById("headerSearchModal").style.width = document.getElementById("headerSearch").offsetWidth + "px";
    }
    render() {
        return (
            <HeaderSearchFunc setSearchActive={this.props.setSearchActive} searchActive={this.props.searchActive} />
        )
    }
}


export default HeaderSearch;


const HeaderSearchFunc = ({ setSearchActive, searchActive }) => {

    const [searchDomain, setSearchDomain] = useState("")
    const [searchStatus, setSearchStatus] = useState("")
    const [searchStatusColor, setSearchStatusColor] = useState("")
    const [searchLoading, setSearchLoading] = useState(false)
    const [searchLink, setSearchLink] = useState("")

    async function searchBar(value) {
        if (!value.includes(".")) {
            value = value.replace(" ", "").toLowerCase();
            if (value.length == 0) {
                setSearchActive(false);
            } else {
                setSearchActive(true);
            }
            setSearchLoading(true);
            setSearchDomain(value);
            setSearchLink("/name/" + punycode.toASCII(value));
            let status;
            if (value.length < 3 || value.length > 15) {
                status = "Invalid";
            } else {
                try {
                    let tokenId = await CloudContracts("eth", process.env.REACT_APP_NETWORK, "full").wnsResolverContract.resolveNameToTokenId(punycode.toASCII(value), "");
                    status = "Registered";
                } catch (e) {
                    status = "Available";
                }
            }
            if (status != "Invalid") {
                setSearchStatusColor("#3482F6");
            } else {
                setSearchStatusColor("#606060");
            }
            setSearchStatus(status);
            setSearchLoading(false);
        }
    }

    useEffect(() => {
        document.body.addEventListener('click', (event) => {
            try {
                let ids = []
                event.path.map((item) => {
                    ids.push(item.id);
                })
                if (!ids.includes("searchButton") && !ids.includes("searchDiv")) {
                    try {
                        setSearchActive(false);
                    } catch (e) { }
                }
            } catch (e) { }
        });
    }, [])

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            window.location = "/name/" + punycode.toASCII((searchDomain.replace(" ", "")).toLowerCase());
        }
    }
    return (
        <div id="searchDiv" className="w-full relative">
            <div className="bg-dark900 rounded-full flex flex-between items-center border-0 border-gray-200 w-full px-2" style={{ zIndex: "100000" }} id="headerSearch">
                <FontAwesomeIcon icon={['fas', 'fa-search']} className="pl-4 text-dark500" />
                <input id="searchInput" type="text" onChange={(e) => { searchBar(e.target.value) }} onKeyDown={handleKeyDown} value={searchDomain} placeholder="Search domains" className="bg-transparent text-white w-full outline-none pl-4 py-3 text-md font-semibold placeholder:text-dark500" ></input>
                <FontAwesomeIcon icon={['fas', 'fa-angle-right']} style={{ fontSize: "100%" }} className="pr-4 text-dark500" />
            </div>
            <div id="" style={{ padding: "0%", display: searchActive ? "block" : "none" }} className="absolute z-20 w-full">
                <div className="rounded-xl mt-2 bg-dark900 w-full border-0 border-light200 px-2 py-4" id="headerSearchModal">
                    <div className="rounded-xl border-0 border-gray-200 w-full">
                        <p className="text-xs text-gray-400 font-bold px-4 py-2">DOMAINS</p>
                        <a className="bg-dark800 hover:bg-dark700 cursor-pointer flex justify-between items-center text-sm px-4 py-2 rounded-2xl w-full" href={searchLink}>
                            <div style={{ width: "70%" }} className="flex items-center gap-x-3">
                                <img src={Logo} className="w-5 h-5 bg-black rounded-md" />
                                <p>
                                    <span className="font-semibold text-white text-lg">{searchDomain}</span>
                                    <span className="text-white text-lg">.web3</span>
                                </p>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }} className="">
                                <div style={{ display: searchLoading ? "block" : "none" }}>
                                    <FontAwesomeIcon icon={['fas', 'fa-circle-notch']} style={{ color: "#606060", fontSize: "100%" }} id="arrowicon" spin />
                                </div>
                                <p style={{ display: searchLoading ? "none" : "block", color: searchStatusColor }} className="font-semibold">{searchStatus}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div >
    );

}